module.exports = __webpack_public_path__ + "static/media/cover2.8c8e7010.jpg";